import { combineReducers } from 'redux'
import { reducer as addSocioEcoData } from './addSocioEcoData'
import { reducer as getSocioEcoData } from './getSocioEcoData'
import { reducer as uploadSocioEcoFile } from './uploadSocioEcoFile'
import { reducer as getSocioStatGeneral } from './getStatGeneral'
import { reducer as getEducationalHealth } from './getEducationalHealth'
import { reducer as getRegionalProjectData } from './getRegionalProjectsData'
import donneesRegionalProject from './donneesRegionalProject'

export default combineReducers({
    addSocioEcoData,
    getSocioEcoData,
    uploadSocioEcoFile,
    getSocioStatGeneral,
    getEducationalHealth,
    getRegionalProjectData,
    donneesRegionalProject,
})
